import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import './assets/styles/app.css';
import App from './App.jsx';
import { reloadForNewBuild } from '@/utils/staleBuild';

window.addEventListener('vite:preloadError', () => {
  reloadForNewBuild();
});

if (window.location.pathname === '/') {
  import('@/views/home/index');
}

createRoot(document.getElementById('root')).render(<StrictMode>
  <App />
</StrictMode>);
